import React from "react";
import Lightbox from "react-images";
import "./App.css";
import copy from "./config/config.json";
import { getFilesWithPrefix } from "./GalleryImport";;

const localized = (copy, lang) => {
  if (!copy) {
    return copy;
  }
  const str =
    "string" === typeof copy ? copy : copy[lang] || Object.values(copy)[0];
  return str.split("\n").map(s => <p>{s}</p>);
};

class Section extends React.Component {
  state = {
    lightboxIsOpen: false,
    currentItem: 0
  };
  thumbnailWidth = obj => {
    if (obj.thumbnailHeight > obj.thumbnailWidth * 1.25) {
      return "thin";
    }
    if (obj.thumbnailHeight * 1.25 < obj.thumbnailWidth) {
      return "wide";
    }
    return "";
  };
  renderGallery = () => (
    <div>
      {this.props.images.map((obj, idx) => (
        <div className={"thumbnailContainer"}>
          <a
            href={obj.src}
            key={idx}
            onClick={e => {
              e.preventDefault();
              this.openLightbox(idx);
            }}
          >
            <img
              className={"thumbnail " + this.thumbnailWidth(obj)}
              src={obj.thumbnail}
            />
            <div className="tagContainer">
              {obj.tags.map((t, idx) => (
                <div key={idx} className={"tag"}>
                  {t.title}
                </div>
              ))}
            </div>
          </a>
        </div>
      ))}
    </div>
  );
  openLightbox = index => {
    this.setState({ lightboxIsOpen: true, currentItem: index });
  };
  closeLightbox = () => this.setState({ lightboxIsOpen: false });
  gotoNext = () => this.setState({ currentItem: this.state.currentItem + 1 });
  gotoPrevious = () =>
    this.setState({ currentItem: this.state.currentItem - 1 });
  render = () => (
    <div>
      <h2>{localized(this.props.copy.title, this.props.language)}</h2>
      {this.props.copy.subtitle && <h3>{localized(this.props.copy.subtitle, this.props.language)}</h3>}
      <div className="section-description">
        {localized(this.props.copy.description, this.props.language)}
      </div>
      {this.props.images && this.props.images.map && this.renderGallery()}
      {this.props.images &&
        this.props.images.map && (
          <Lightbox
            items={this.props.images}
            isOpen={this.state.lightboxIsOpen}
            currentItem={this.state.currentItem}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            onClose={this.closeLightbox}
          />
        )}
      <div style={{ clear: "both" }} />
    </div>
  );
}

export default class App extends React.Component {
  state = {
    sections: [],
    language:
      localStorage.getItem("lang") ||
      "en"
  };

  setLanguage = lang => {
    this.setState({ language: lang });
    localStorage.setItem("lang", lang);
  };

  componentWillMount = async props => {
    try {
      const ascend = getFilesWithPrefix("Ascendentes");
      const mecanica = getFilesWithPrefix("Mecanica");

      this.setState({
        sections: [
          {
            copy: copy.sections.home
          },
          {
            copy: copy.sections.Mecanica,
            images: await mecanica
          },
          {
            copy: copy.sections.Ascendentes,
            images: await ascend
          }
        ]
      });
    } catch (e) {
      console.log(e);
    }
  };
  render() {
    return (
      <div className="main">
        <div className="language">
          <a onClick={() => this.setLanguage("es")}>🇨🇱 ES</a> •{" "}
          <a onClick={() => this.setLanguage("en")}>🇺🇸 EN</a>
        </div>
        <h1>Gaad Baytelman</h1>
        {this.state.sections.map((s, idx) => (
          <Section
            key={idx}
            index={idx}
            {...s}
            language={this.state.language}
          />
        ))}
        <div className="footer">
          <a href="mailto:gaad@baytelman.com">gaad@baytelman.com</a> •
          +(56-9)9827-1517 •{" "}
          <a href="http://fb.com/gaadBaytelmanArte">fb.com/gaadBaytelmanArte</a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js